import { render } from "./ComponentListSelection.vue?vue&type=template&id=2429646a&scoped=true"
import script from "./ComponentListSelection.vue?vue&type=script&lang=js"
export * from "./ComponentListSelection.vue?vue&type=script&lang=js"

import "./ComponentListSelection.vue?vue&type=style&index=0&id=2429646a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2429646a"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
